var ResponseModel = /** @class */ (function () {
    function ResponseModel() {
    }
    ResponseModel.isOk = function (res) {
        return res.status === "OK";
    };
    return ResponseModel;
}());
export { ResponseModel };
